// import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'

const riskAppeal = {
  state: {
    riskTabIndex: 0,
    isShowVideoPopup: false, // 视频显示视频预览
    closeVideoPopup: false, // 控制关闭弹框
    quickSearchList: [] // 快速搜索
  },
  mutations: {
    /**
     * @function 风控列表tab状态
     * @param {Number} val
     */
    [types.SET_RISK_TAB_STATUS] (state, val) {
      state.riskTabIndex = val
    },
    /**
     * @function 风控列表快速搜索
     * @param {Array} val
     */
    [types.SET_QUICK_SEARCH] (state, val = []) {
      state.quickSearchList = val
    },
    /**
     * @function 是否显示视频弹框
     * @param {Boolean} val
     */
    [types.SET_SHOW_VIDEO] (state, val) {
      state.isShowVideoPopup = val
    },
    /**
     * @function 关闭视频弹框
     * @param {Boolean} val
     */
    [types.SET_CLOSE_VIDEO] (state, val) {
      state.closeVideoPopup = val
    }
  },
  getters,
  types
}
export default riskAppeal
